export const UserSessionStartEventIdentities = {
    WebSessionInitialized: {
        eventType: "Init",
        eventObject: "WebSession",
    },
    NativeSessionInitialized: {
        eventType: "Init",
        eventObject: "NativeSession",
    },
    ServerSessionInitialized: {
        eventType: "Init",
        eventObject: "ServerSession",
    },
};
